import { gql } from "@apollo/client";
import { RHTVPageFieldsFragment } from "@/fragments/RockHallTv";

export const PageByLanguage = gql`
  ${RHTVPageFieldsFragment}
  query RHTVPageByLanguage($uri: String!, $language: String!) {
    rhNodeByUri(uri: $uri, language: $language) {
      ... on Page {
        ...RhtvPageFields
      }
    }
  }
`;
